import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const AdminReportsPage = lazy(() => import("./AdminReportsPage"));
const ScheduledReportsFormPage = lazy(
  () => import("./ScheduledReportsFormPage")
);
const ScheduledReportsPage = lazy(() => import("./ScheduledReportsPage"));

export type ReportsPagesNavigationParams = {
  reportsTasks: PageNavParams;
  reportsTimeClock: PageNavParams;
  reportsScheduled: PageNavParams;
  reportsScheduledForm: PageNavParams;
  reportsScheduledFormEdit: PageNavParams<{ reportId: string }>;
};

export const reportsPagesNavigationConfig: ModulePagesConfig<ReportsPagesNavigationParams> =
  {
    reportsTasks: {
      element: <AdminReportsPage />,
      path: "reports/tasks",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.taskReports,
      requiredModules: [SubscriptionPlanModuleId.reports],
    },
    reportsTimeClock: {
      element: <AdminReportsPage />,
      path: "reports/timeclock",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.timeClockReports,
      requiredModules: [
        SubscriptionPlanModuleId.reports,
        SubscriptionPlanModuleId.timeLog,
      ],
    },
    reportsScheduled: {
      element: <ScheduledReportsPage />,
      path: "scheduled-reports",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.scheduledReports,
      requiredModules: [SubscriptionPlanModuleId.reports],
    },
    reportsScheduledForm: {
      element: <ScheduledReportsFormPage />,
      path: "scheduled-reports-form",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.scheduledReports,
      requiredModules: [SubscriptionPlanModuleId.reports],
    },
    reportsScheduledFormEdit: {
      element: <ScheduledReportsFormPage />,
      path: "scheduled-reports-form/:reportId",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.scheduledReports,
      requiredModules: [SubscriptionPlanModuleId.reports],
    },
  };
